import React from "react";
import useDeliveryChallanForm from "./useDeliveryChallanForm";
import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import Select from "react-select";
import ItemFields from "./ItemFields";
import Style from "../../../Employees/Delivery/EditPrint/editPrint.module.scss";

const gliBadgeStyle = {
  padding: "4px 8px",
  borderRadius: "15px",
  backgroundColor: "var(--pro-primary)",
  color: "#fff",
  fontSize: "12px",
};

const gliRemoveBtnStyle = {
  background: "transparent",
  paddingLeft: "8px",
  border: "none",
  color: "#ffffff",
  cursor: "pointer",
  fontSize: "14px",
  lineHeight: "1",
};

const DeliveryChallanForm = () => {
  const {
    formik,
    isEdit,
    basicData,
    getFieldError,
    handleAddField,
    handleCloseModal,
    handleRemoveGli,
  } = useDeliveryChallanForm();

  const customerOptions = [
    ...(basicData?.data?.supplier ?? []),
    ...(basicData?.data?.shop ?? []),
  ];

  return (
    <>
      <div className={Style.address}>
        <small>Selected GLI Numbers</small>
        <div className="pro-d-flex pro-flex-wrap pro-gap-2 pro-mt-2">
          {formik.values.gli_numbers.map((gli, index) => (
            <span key={gli} className="pro-badge badge-primary" style={gliBadgeStyle}>
              {gli}
              <button
                type="button"
                onClick={() => handleRemoveGli(index)}
                style={gliRemoveBtnStyle}
              >
                ×
              </button>
            </span>
          ))}
          {formik.values.gli_numbers.length === 0 && (
            <span className={Style.display_text} style={{ color: "red" }}>
              No GLI numbers selected
            </span>
          )}
        </div>
        {formik.touched.gli_numbers && formik.errors.gli_numbers && (
          <small className="pro-text-danger pro-mt-1">
            {formik.errors.gli_numbers}
          </small>
        )}
      </div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Customer Name
        </label>
        <Select
          id="customer_id"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          isMulti={false}
          name="customer_id"
          options={customerOptions}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) => option?.name}
          value={customerOptions?.filter(
            (p) => p._id === formik.values.customer_id,
          )}
          onChange={(value) => {
            formik.setFieldValue("customer_id", value?._id);
            formik.setFieldValue("customer_name", value?.name ?? "");
            formik.setFieldValue(
              "address_line1",
              value?.billing_address?.address_line1 ?? "",
            );
            formik.setFieldValue(
              "address_line2",
              value?.billing_address?.address_line2 ?? "",
            );
            formik.setFieldValue(
              "city",
              value?.billing_address?.city ?? "",
            );
            formik.setFieldValue(
              "contact_number",
              value?.contact_number ?? "",
            );
            formik.setFieldValue("gst_number", value?.gst_number ?? "");
          }}
          menuPlacement="auto"
        />
      </div>
      <div className="input-wrap">
        <Input
          label={"Customer Name"}
          type="text"
          id="customer_name"
          name="customer_name"
          className={`pro-input lg ${
            getFieldError("customer_name") && " error"
          }`}
          {...formik.getFieldProps("customer_name")}
          error={getFieldError("customer_name")}
          errorMessage={getFieldError("customer_name")}
        />
      </div>
      <div className="input-wrap">
        <Input
          label={"Address Line 1"}
          type="text"
          id="address_line1"
          name="address_line1"
          className={`pro-input lg ${
            getFieldError("address_line1") && " error"
          }`}
          {...formik.getFieldProps("address_line1")}
          error={getFieldError("address_line1")}
          errorMessage={getFieldError("address_line1")}
        />
      </div>
      <div className="input-wrap">
        <Input
          label={"Address Line 2"}
          type="text"
          id="address_line2"
          name="address_line2"
          className={`pro-input lg ${
            getFieldError("address_line2") && " error"
          }`}
          {...formik.getFieldProps("address_line2")}
          error={getFieldError("address_line2")}
          errorMessage={getFieldError("address_line2")}
        />
      </div>
      <div className="input-wrap">
        <Input
          label={"City"}
          type="text"
          id="city"
          name="city"
          className={`pro-input lg ${getFieldError("city") && " error"}`}
          {...formik.getFieldProps("city")}
          error={getFieldError("city")}
          errorMessage={getFieldError("city")}
        />
      </div>
      <div className="input-wrap">
        <Input
          label={"Contact Number"}
          type="text"
          id="contact_number"
          name="contact_number"
          className={`pro-input lg ${
            getFieldError("contact_number") && " error"
          }`}
          {...formik.getFieldProps("contact_number")}
          error={getFieldError("contact_number")}
          errorMessage={getFieldError("contact_number")}
        />
      </div>
      <div className="input-wrap">
        <Input
          label={"GST Number"}
          type="text"
          id="gst_number"
          name="gst_number"
          className={`pro-input lg ${getFieldError("gst_number") && " error"}`}
          {...formik.getFieldProps("gst_number")}
          error={getFieldError("gst_number")}
          errorMessage={getFieldError("gst_number")}
        />
      </div>
      <div className="input-wrap">
        <Input
          label={"Supplier Challan Number"}
          type="text"
          id="supplier_challan_number"
          name="supplier_challan_number"
          className={`pro-input lg ${
            getFieldError("supplier_challan_number") && " error"
          }`}
          {...formik.getFieldProps("supplier_challan_number")}
          error={getFieldError("supplier_challan_number")}
          errorMessage={getFieldError("supplier_challan_number")}
        />
      </div>
      <div className={Style.address}>
        {formik.values.item_fields.map((item, index) => (
          <ItemFields
            key={`item-${index}`}
            fieldIndex={index}
            formik={formik}
            canRemove={formik.values.item_fields.length > 1}
          />
        ))}
        <Button
          className={`pro-btn-primary lg pro-w-100 pro-mt-4`}
          onClick={handleAddField}
        >
          {` Add Another`}
        </Button>
      </div>
      <div className="input-wrap">
        <Input
          label={"Total Amount"}
          type="text"
          id="total_amount"
          name="total_amount"
          className={`pro-input lg ${
            getFieldError("total_amount") && " error"
          }`}
          {...formik.getFieldProps("total_amount")}
          error={getFieldError("total_amount")}
          errorMessage={getFieldError("total_amount")}
          disabled={true}
        />
      </div>
      <div className="input-wrap">
        <Input
          label={"Remarks"}
          type="text"
          id="remarks"
          name="remarks"
          className={`pro-input lg ${getFieldError("remarks") && " error"}`}
          {...formik.getFieldProps("remarks")}
          error={getFieldError("remarks")}
          errorMessage={getFieldError("remarks")}
        />
      </div>
      <div
        className={`col-12 pro-d-flex pro-justify-end offcanvas-footer-sticky-btn pro-mt-5`}
      >
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleCloseModal}
        >
          Cancel
        </Button>
        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="submit"
          onClick={formik.handleSubmit}
          disabled={formik.values.gli_numbers.length === 0}
        >
          {isEdit ? "Update" : "Submit"}
        </Button>
      </div>
    </>
  );
};

export default DeliveryChallanForm;
